































































































import { Component, Vue, Prop } from 'vue-property-decorator'

import Passenger from '@/models/passenger'
import Recipient from '@/models/recipient'
import { VisaLetterData } from '@/models/visa-letter-data'

import dayjs, { Dayjs } from '@/dayjs'

@Component
export default class MedexperienceBody extends Vue {
  @Prop() passengers!: Passenger[]
  @Prop() recipients!: { [id: number]: Recipient }
  @Prop() visaLetterData!: VisaLetterData

  get recipientPassengers(): Passenger[] {
    return this.passengers.filter(
      (passenger) =>
        this.recipients[passenger.id] && this.recipients[passenger.id].isChosen,
    )
  }

  get departure(): Dayjs {
    return dayjs.utc(this.visaLetterData.departure)
  }

  get finishDate(): Dayjs {
    return dayjs.utc(this.visaLetterData.finishDate)
  }
}
